<template>
  <div>
    <v-box v-if="!checkIsCordova" :scrollable="false" @keydown="keySpy">
    <ImageEditor v-if="image" :src="image.url" ref="editor"></ImageEditor>
    </v-box>
    <v-box v-else :scrollable="false">
    <ImageEditor v-if="image" :src="addCordovaUrl + image.url" ref="editor"></ImageEditor>
    </v-box>

    <FooterNavbar data-test-path="pintura-editor-footer">
      <CloseButton :disabled="saveInProgress" :read-only="false" @close="cancel" ></CloseButton>
      <FooterButton
          v-if="!singleImageEditor"
          type="Save"
          :disabled="saveInProgress"
          dataTestPath="save-as-new"
          :label="SAVE_AS_NEW_LABEL"
          @save="saveAs"
          button-style="width: auto; display: inline-flex; align-items: center; white-space: nowrap;"
      >
        <template slot="icon">
          <font-awesome-layers>
            <font-awesome-icon icon="floppy-disk" transform="shrink-1 left-3 top-2" />
            <font-awesome-icon icon="plus" transform="shrink-6 right-7 down-7" />
          </font-awesome-layers>
        </template>
      </FooterButton>
      <FooterButton
          type="Save"
          :disabled="saveInProgress"
          :label="!singleImageEditor ? REPLACE_LABEL : null"
          @save="!singleImageEditor ? saveAndReplace() : save()"
      >
        <template slot="icon">
          <font-awesome-layers>
            <font-awesome-icon icon="floppy-disk" transform="shrink-1 left-3 top-2" />
            <font-awesome-icon icon="recycle" transform="shrink-6 right-7 down-7" />
          </font-awesome-layers>
        </template>
      </FooterButton>
    </FooterNavbar>
  </div>
</template>

<script>

import ImageEditor from '@/components/img/ImageEditor';
import Activity from "@/activity/Activity";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import DialogManager from "@/utils/DialogManager";
import FileInRepository from "@/server/com/silkplm/model/files/FileInRepository";
import PinturaImageEditorResult from "@/components/img/PinturaImageEditorResult";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import Rpc from "@/Rpc";

export default {
  name: "PinturaImageEditor",
  components: {FooterButton, FooterNavbar, VBox, ImageEditor, CloseButton},
  computed:{
    checkIsCordova(){
      return window.isCordova
    },
    addCordovaUrl(){
      return window.cordovaUrl
    }
  },
  methods: {
    keySpy(ev){
      console.log(ev);
    },
    ...Activity.methods,

    mounted() {
      console.log("load pinttura image editor component");
    },
    getTitle() {
      if (this.image){
        return this.image.data.name;
      }
      else {
        return "Editing image"
      }
    },

    async save(){
      this.saveInProgress = true;
      try {
        const imageFile = await this.$refs.editor.save();
        try {
          if (this.uploadImage) {
            const newImageFile = await Rpc.BusinessEntities.uploadImage(imageFile, "").lock()
            if (newImageFile) {
              this.result = new PinturaImageEditorResult();
              this.result.newFile = newImageFile;
              this.shouldClose = false;
            }
          }
          this.close();

        } catch (e) {
          if (e instanceof RpcInputValidationException) {
            await DialogManager.info($tr('imageViewer.invalid', 'Invalid image format'), e.fields.image.errorMessage);
          }
        }
      } finally {
        this.saveInProgress = false;
      }
    },

    async saveAndReplace() {
      this.saveInProgress = true;
      try {
        if (await DialogManager.yesNo($tr('imageViewer.replace', 'Replace image'),
            $tr('imageViewer.sure.replace', 'Are you sure you want to replace this image?'))) {
          const imageFile = await this.$refs.editor.save();
          let newImageFile = null;
          if (window["isCordova"]) {
            let object = imageFile.name[0];
            object.name = this.image.data.name.replace(/ /g, "_") + ".png";
            newImageFile = await Rpc.BusinessEntities.replaceFile(this.image, object).lock();
          } else {
            newImageFile = await Rpc.BusinessEntities.replaceFile(this.image, imageFile).lock();
          }
          this.result = new PinturaImageEditorResult();
          this.result.replace = true;
          this.result.newFile = newImageFile;
          this.result.deletedFile = this.image;
          this.shouldClose = false;
          this.close();
        }
      } finally {
        this.saveInProgress = false;
      }
    },

    async saveAs() {
      this.saveInProgress = true;
      try {
        let newFileName = await DialogManager.lineInput($tr('imageViewer.save', 'Save as'),
            $tr('imageViewer.enter.name', 'Enter a new file name'),
            "1_" + this.image.data.name, {
              okTitle: "Save",
              validationFunction: async (value) => {
                return Rpc.Validators.validateImageFileName(value);
              }
            });
        if (newFileName) {
          const imageFile = await this.$refs.editor.save();
          let newImageFile = null;
          if (window["isCordova"]) {
            let object = imageFile.name[0];
            object.name = newFileName;
            newImageFile = await Rpc.BusinessEntities.uploadImage(object, newFileName).lock();
          } else {
            newImageFile = await Rpc.BusinessEntities.uploadImage(imageFile, newFileName).lock();
          }
          this.result = new PinturaImageEditorResult();
          this.result.newFile = newImageFile;
          this.shouldClose = false;
          this.close();
        }
      } finally {
        this.saveInProgress = false;
      }
    },


    beforeClose() {
      if(this.result){
        this.setResult(this.result);
      }
    },

    async canClose(){
      return await DialogManager.canClose(this.shouldClose);
    },

    cancel(){
      this.close();
    }
  },

  props: {
    uploadImage: {type: Function, default: null},
    image:       {type: FileInRepository, default: null},
    singleImageEditor: {type: Boolean, default: false},
  },

  data: () => ({
    /** @type{PinturaImageEditorResult} */
    result: null,
    saveInProgress: false,
    REPLACE_LABEL: $tr("Replace","Replace"),
    SAVE_AS_NEW_LABEL: $tr("SaveAsNew","Save as new"),
    shouldClose: true
  })
}
</script>